import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import FacebookLogin from "react-facebook-login";

import AppleIcon from "@mui/icons-material/Apple";
import { Sociallogin, loginAdmin } from "../../redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetLogin } from "../../redux/authSlice";
import Grid from "@mui/system/Grid";
import Stack from "@mui/system/Stack";
import { useGoogleLogin, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Google } from "../../icons/icons";
import { Facebook } from "../../icons/icons";
import Logo from "../../assets/images/login/logo.png";
import AgreeSec from "../agree-sec";
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { isSuccess, social, isVerified } = useSelector((state) => state.admin);
  const [login, setLogin] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });
  const dispatch = useDispatch();
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const navigate = useNavigate();
  // const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear the error message for the specific field
    setErrors((prevState) => ({
      ...prevState,
      [name]: "", // Clear the error message for the current field being edited
    }));

    // Update the login state
    setLogin((prevLogin) => ({
      ...prevLogin,
      [name]: value,
    }));
  };
  const responseFacebook = async (response) => {
    if (response.accessToken) {
      const apiPayload = {
        email: response.email || "",
        name: response.name || "",
        phone_number: "",
        social_id: response.id || "",
        idToken: response.accessToken,
        login_type: "facebook",
        device_type: "android",
      };
      dispatch(Sociallogin(apiPayload));
    } else {
      console.error("Login failed:", response);
    }
  };
  const [user, setUser] = useState([]);

  const validateForm = () => {
    let emailError = "";
    let passwordError = "";

    // Email validation
    if (!login?.email) {
      emailError = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(login.email)) {
      emailError = "Please enter valid email address";
    }
    if (!login?.password) {
      passwordError = "Password is required";
    }
    // else if (login.password.length < 6) {
    //   passwordError = "Password must be at least 6 characters";
    // }
    setErrors({ email: emailError, password: passwordError });

    return !emailError && !passwordError;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      // setLoginMethod("standard");
      await dispatch(loginAdmin(login));
      dispatch(resetLogin());
      setLogin();
    } else {
      console.log("Please enter valid data.");
    }
  };

  useEffect(() => {
    // Load Facebook SDK script
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "1471401760929675",
        cookie: true,
        xfbml: true,
        version: "v11.0",
      });
    };
  }, []);
  const logins = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      // setLoading(true);
      const { access_token } = codeResponse;

      try {
        const response = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }
        );

        const profile = await response.json();

        const apiPayload = {
          email: profile.email || "",
          name: profile.name || "",
          phone_number: "",
          social_id: profile.sub || "",
          idToken: access_token,
          login_type: "google",
          device_type: "android",
        };
        dispatch(Sociallogin(apiPayload));
        // setLoading(false)
      } catch (error) {
        console.error("Error fetching Google profile:", error);
      }
    },
    onError: (error) => console.log("Login Failed:", error),
  });
  useEffect(() => {
    // console.log("isSuccess:", isSuccess, "social:", social, "isVerified:", isVerified); // Debugging info

    if ((isSuccess || social) && typeof isVerified === "boolean") {
      if (isVerified === false) {
        navigate("/bonus");
      } else {
        navigate("/chat");
      }
    }
  }, [isSuccess, social, isVerified, navigate]);

  // useEffect(() => {
  //   if (social && isVerified) {
  //     if (isVerified === false) {
  //       // Navigate to the bonus page if it's the first-time login
  //       navigate("/bonus");
  //     } else {
  //       // Navigate to the chat page if the user is verified
  //       navigate("/chat");
  //     }

  //   }
  // }, [social, isVerified, navigate]);
  return (
    <Box className="login-wrapper">
      <Grid
        container
        spacing={{ xs: 0, sm: 2 }}
        sx={{ height: { xs: "auto", md: "100%" } }}
      >
        <Grid size={{ xs: 12, md: 6, xl: 5, xxl: 6 }}>
          <Box
            sx={{ m: { xs: "20px", sm: "32px", md: "32px 80px" } }}
            onClick={() => navigate("/")}
          >
            <img src={Logo} alt="logo" />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 6, xl: 7, xxl: 6 }}>
          <Stack
            sx={{
              height: { xs: "85vh", md: "100%" },
              width: { xs: "90%", sm: "70%", md: "50%", xl: "60%", xxl: "50%" },
              margin: "0 auto",
              position: "relative",
            }}
            justifyContent={{ xs: "center", md: "start" }}
            alignItems={"center"}
          >
            <Box
              sx={{
                width: "100%",
                paddingTop: { xs: "0", sm: "50px", xl: "50px", xxl: "100px" },
              }}
            >
              <Typography
                variant="h1"
                sx={{ color: "#fff", fontSize: "40px", fontWeight: "700" }}
                fullWidth
              >
                Login
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: "16px",
                  fontWeight: "500",
                  mt: { xs: "4px", xl: "12px" },
                  mb: { xs: "12px", xl: "28px" },
                }}
              >
                Enter your details to Login
              </Typography>
            </Box>

            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ width: "100%" }}
            >
              <FormControl fullWidth sx={{ mb: 2 }}>
                <OutlinedInput
                  name="email"
                  value={login?.email || ""}
                  placeholder="Please enter your registered email id "
                  onChange={handleChange}
                  error={!!errors.email}
                  className="custom-input"
                  sx={{ color: "#fff" }}
                />
                <Typography variant="caption" sx={{ color: "#ff6666" }}>
                  {errors.email}
                </Typography>
              </FormControl>

              <FormControl fullWidth>
                <OutlinedInput
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={login?.password}
                  onChange={handleChange}
                  error={!!errors.password}
                  sx={{ color: "#fff" }}
                  endAdornment={
                    <InputAdornment position="end" sx={{ pr: "16px" }}>
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        sx={{ color: "#fff" }}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <Typography variant="caption" sx={{ color: "#ff6666" }}>
                  {errors.password}
                </Typography>
              </FormControl>
              <Box
                sx={{
                  textAlign: "right",
                  mb: { xs: "8px", xl: "24px" },
                  mt: { xs: "0px", xl: "12px" },
                }}
              >
                <Typography
                  component={Link}
                  to="/forget"
                  sx={{
                    color: "#84A1D6",
                    textAlign: "right",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "500",
                    textDecoration: "none",
                  }}
                >
                  Forgot Password?
                </Typography>
              </Box>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  mb: { xs: 0, xl: 2 },
                  p: { xs: "6px", xl: "10px" },
                  backgroundColor: "primary.Main",
                  fontSize: "18px",
                  fontWeight: "500",
                  borderRadius: "50px",
                  height: "auto",
                }}
              >
                Login
              </Button>
              <Box sx={{ width: { xs: "90%", xl: "80%" }, margin: "0 auto" }}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{
                    mt: { xs: "12px", xl: "24px" },
                    mb: { xs: "8px", xl: "20px" },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: "20%", xl: "30%" },
                      background: "#CBD2E247",
                      height: "1px",
                    }}
                  ></Box>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#CBD2E2",
                      fontSize: "16px",
                      fontWeight: "400",
                      position: "relative",
                    }}
                  >
                    or continue with
                  </Typography>
                  <Box
                    sx={{
                      width: { xs: "20%", xl: "30%" },
                      background: "#CBD2E247",
                      height: "1px",
                    }}
                  ></Box>
                </Stack>

                <Box
                  sx={{
                    display: "flex",
                    // justifyContent: "space-between",
                    justifyContent: "center",
                    alignItems: "stretch",
                    mb: { xs: "16px", xl: "22px" },
                    "& .css-4aijqd-MuiButtonBase-root-MuiButton-root": {
                      borderColor: "red",
                      border: "0px solid red",
                    },
                  }}
                >
                  <Button
                    sx={{
                      mr: 1,
                      color: "#fff",
                      borderRadius: "50px",
                      background: "#1B2338",
                      padding: { xs: "8px", xl: "10px" },
                      fontSize: { xs: "14px", xl: "16px" },
                      fontWeight: "400",
                      height: "auto",
                      width: "48%",
                    }}
                    startIcon={<Google />}
                    onClick={logins}
                  >
                    Google
                  </Button>
                  {/* <Box sx={{ width: '48%', }}>
                    <FacebookLogin
                      appId="1471401760929675"
                      autoLoad={false}
                      fields="name,email,picture"
                      callback={responseFacebook}
                      textButton="Facebook"
                      cssClass="my-facebook-button-class"
                      icon={
                        <Box sx={{ mr: '8px' }}>
                          <Facebook
                            disabled={false} />
                        </Box>
                      }
                      disabled={false}
                    />
                  </Box> */}
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      color: "#CBD2E2",
                      textAlign: "center",
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                    component={Link}
                    to="/signup"
                  >
                    Don’t have an account?{" "}
                    <span style={{ color: "#84A1D6" }}>Sign up</span>
                  </Typography>
                </Box>
              </Box>
            </Box>

            <AgreeSec />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Login;
